

const SERVICE_FEE_PERCENT = 0.03; // 3% of subtotal
const SERVICE_FEE_FLAT = 1;       // R1 flat per transaction

/**
 * Return the DB price as-is for display — no markup.
 * Returns 0 for free / zero-price tickets.
 * @param {number|string} dbPrice
 * @returns {number}
 */
export function getDisplayPrice(dbPrice) {
  const numericPrice = typeof dbPrice === 'number' ? dbPrice : Number.parseFloat(String(dbPrice).replace(/[R\s,]/g, ''));
  if (Number.isNaN(numericPrice) || numericPrice <= 0) return 0;
  return numericPrice;
}

/**
 * Calculate the service fee charged on top of the subtotal.
 * Formula: 3% × subtotal + R1
 * Returns 0 for free orders.
 * @param {number} subtotal - Sum of all flat ticket prices
 * @returns {number} Service fee rounded to 2 decimal places
 */
export function calculateServiceFee(subtotal) {
  if (!subtotal || subtotal <= 0) return 0;
  return Math.round((subtotal * SERVICE_FEE_PERCENT + SERVICE_FEE_FLAT) * 100) / 100;
}

/**
 * Calculate the display price for a given ticket quantity (flat × qty).
 * @param {number|string} dbUnitPrice
 * @param {number} quantity
 * @returns {number}
 */
export function getDisplayTotal(dbUnitPrice, quantity = 1) {
  return getDisplayPrice(dbUnitPrice) * quantity;
}

/**
 * Format a price as a ZAR currency string.
 * @param {number|string} price
 * @returns {string} e.g. "R 100.00"
 */
export function formatPrice(price) {
  let numericPrice;
  if (typeof price === 'string') {
    numericPrice = Number.parseFloat(price.replace(/[R\s,]/g, ''));
  } else {
    numericPrice = price;
  }

  if (Number.isNaN(numericPrice)) return 'R 0.00';

  const roundedPrice = Math.round(numericPrice * 100) / 100;
  const parts = roundedPrice.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `R ${parts.join('.')}`;
}

/**
 * Parse a formatted price string back to a number.
 * @param {string|number} price
 * @returns {number}
 */
export function parseAmountToNumber(price) {
  if (typeof price === 'number') return price;
  if (!price) return 0;
  const numeric = Number.parseFloat(String(price).replace(/[R\s,]/g, ''));
  return Number.isNaN(numeric) ? 0 : numeric;
}
